export default __webpack_public_path__ + "static/media/Brocast-10-Tab-eng.58b9230a.jpg";